<template>
  <div class="concern-keywords-container">
    <div class="row concern-keywords-header">
      <div class="row concern-keywords-tabs">
          <div
            class="tab-item" 
            :class="{'tab-item-active': item === selectedOptionTab}" 
            v-for="(item, index) in tabs" 
            :key="index"
            @click="onTabClick(item, index)"
          >
          <span class="tab-item-title" v-if="item.length<=9">{{item}}</span>
          <el-popover
            placement="bottom-start"
            trigger="hover"
            :visible-arrow="false"
            popper-class="tips"
          >
            <span class="delete-hover-title" style="position:absolute,top:100px,left:5px,color:#000">
              {{item}}
            </span>
            <div slot="reference" class="delete-hover">
             <span class="tab-item-title" v-if="item.length>9">{{item}}</span>
            </div>
          </el-popover>
          </div>
      </div>
      <div class="title-button" v-if="showHeaderBtn" @click="onChangeTabsShow">
        <img class="arrow-img" v-if="showAllTabs" src="../../assets/img/up-arrow1.svg" />
        <img class="arrow-img" v-else src="../../assets/img/down-arrow1.svg" />
      </div>
    </div>
    <PersonNewsList :personCount="personCount" :personNameData="selectedOptionTab" ref="concernPerson"></PersonNewsList>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';
import Mark from 'mark.js';
import PersonNewsList from '@/components/news-monitor/PersonNewsList';

export default {
  data() {
    return {
      headerTagElementHeight: 0,
      headerTagElement: null,
      showAllTabs: true,
      showHeaderBtn: false,
      keywordElement: null,
      tabs: [],
      selectedOptionTab: ''
    };
  },
  props: ['personCount'],
  methods: {
    manageConcerns() {
      this.$router.push({
        path: '/follow',
        query: {
          type: 'keywords'
        }
      });
    },
    onChangeTabsShow() {
      this.showAllTabs = !this.showAllTabs;
      if (!this.showAllTabs) {
        this.headerTagElement.style.height = '44px';
        this.headerTagElement.style.overflow = 'hidden';
        this.headerTagElement.style.transition = 'all .3s ease-in';
      } else {
        this.headerTagElement.style.height = `${this.headerTagElementHeight}px`;
        this.headerTagElement.style.overflow = 'auto';
        this.headerTagElement.style.transition = 'all .3s ease-in';
      }
    },
    onTabClick(item) {
      this.selectedOptionTab = item;
    },
    getMonitorPersonList() {
      QuestionQuery.getMonitorPersonNameList(this.username).then(res => {
        this.tabs = res.map(item => item.person);
        this.selectedOptionTab = this.tabs[0];
        this.$nextTick(() => {
          this.headerTagElement = document.querySelector('.concern-keywords-header');
          this.headerTagElementHeight = document.querySelector('.concern-keywords-header').clientHeight;
          if (this.headerTagElementHeight > 61) {
            this.showHeaderBtn = true;
            this.headerTagElement.style.height = '44px';
            this.headerTagElement.style.overflow = 'hidden';
            this.showAllTabs = false;
          } else {
            this.showHeaderBtn = false;
            this.headerTagElement.style.height = '44px';
            this.headerTagElement.style.overflow = 'hidden';
          }
        });
      });
    }
  },
  updated() {
    const instance = new Mark(document.querySelectorAll('.news-item-container-title-left'));
    const instanceContent = new Mark(document.querySelectorAll('.summary-content'));
    if (this.highlight && this.highlight.title.length) {
      instance.mark(this.highlight.title || [], {
        element: 'span',
        className: 'highlight'
      });
    }
    if (this.highlight && this.highlight.content.length) {
      instanceContent.mark(this.highlight.content || [], {
        element: 'span',
        className: 'highlight'
      });
    }
  },
  components: {
    PersonNewsList
  },
  mounted() {
    this.username = authService.getLoggedUserName();
    this.getMonitorPersonList();
  }
};
</script>

<style  lang="scss" scoped>
  .concern-keywords-container {
    width: 100%;
    .concern-keywords-header {
      padding: 12px 24px 0;
      min-height: 44px;
      background-color: #ffffff;
      box-shadow: inset 0px -1px 0px 0px#f7f7fa;
      .concern-keywords-tabs {
        width: 1120px;
        height: 100%;
        flex-wrap: wrap;
        font-size: 14px;
        .tab-item-title {
          display: inline-block;
          max-width: 126px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .tab-item {
          margin-right: 32px;
          margin-bottom: 10px;
          color: #747990;
          cursor: pointer;
        }
        .tab-item-active {
          position: relative;
          color: #171f46;
        }
        .tab-item-active::after {
          content: "";
          position: absolute;
          top: 25px;
          left: 50%;
          transform: translateX(-50%);
          width: 14px;
          height: 3px;
          background-color: #171f46;
        }
      }
      .title-button {
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        margin-top: -2px;
        background-color: rgba(0, 11, 92, 0.03);
        border-radius: 2px;
        cursor: pointer;
        &:hover {
          background-image: linear-gradient(
              rgba(0, 0, 0, 0.1),
              rgba(0, 0, 0, 0.1)
            ),
            linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
          background-blend-mode: normal, normal;
        }
        &:active {
          background-color: #e6eeff;
        }
        .arrow-img {
          margin-top: -2px;
          width: 16px;
          vertical-align: middle;
        }
      }
    }
  }
</style>
<style lang="scss">
  .el-popover.el-popper.tips {
    min-width: 300px;
    height: 4px;
    color: transparent;
    border: none;
    font-size: 12px;
    background-color: transparent;
    box-shadow: none;
    /deep/ .delete-hover-title {
      position: relative;
      top: -20px;
      left: -15px;
      min-width: 500px;
      height: 26px;
      background-color: #3d414f;
      border-radius: 2px;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 18px;
      letter-spacing: 0px;
      color: #ffffff;
      padding: 4px;
    }
  }
</style>
